import { render, staticRenderFns } from "./ModuleWiseBarChart.vue?vue&type=template&id=98d1aba4&scoped=true&"
import script from "./ModuleWiseBarChart.vue?vue&type=script&lang=js&"
export * from "./ModuleWiseBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d1aba4",
  null
  
)

export default component.exports